import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
import { userIcon } from "../../../../assets/icons";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import classes from "./RatingOperatorInfo.module.scss";

type RatingOperatorInfoProps = {
  textColor: string;
  operatorName: string;
  photoUrl?: string | null;
  compact?: boolean;
};

export const RatingOperatorInfo: FC<RatingOperatorInfoProps> = ({
  textColor,
  operatorName,
  photoUrl: photoUrlRaw,
  compact,
}) => {
  const photoUrl = resolveMediaUrl(photoUrlRaw);
  const [photoFailed, setPhotoFailed] = useState(false);

  useEffect(() => {
    setPhotoFailed(false);
  }, [photoUrl]);

  const showPhoto = Boolean(photoUrl) && !photoFailed;

  return (
    <div
      className={classNames(classes.root, compact && classes.compact)}
      style={{ color: textColor }}
    >
      <div className={classes.photoWrap}>
        {showPhoto ? (
          <img
            className={classes.photo}
            src={photoUrl!}
            alt=""
            onError={() => setPhotoFailed(true)}
          />
        ) : (
          <div className={classes.placeholder} aria-hidden>
            <img src={userIcon} alt="" className={classes.placeholderIcon} />
          </div>
        )}
      </div>
      <p className={classes.caption}>Вас обслуживал(а) — {operatorName}</p>
    </div>
  );
};
